module.exports = __webpack_public_path__ + "static/media/mold-bin.c744d021.jpg";